<template>
  <v-card outlined>
    <v-card-title>{{ `${$t('sod.ttl.ra')} ${$t('common.define')}` }}</v-card-title>
    <v-card-text class="pa-2 pt-0">
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ `${$t('sod.ttl.ra')} ${$t('sod.ttl.nm')}` }}</p></v-col>
        <v-col cols="4"><v-text-field v-model="item.raNm" outlined dense hide-details :disabled="isNotEditable"/></v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="1"><p class="label">{{ $t('sod.ttl.risk.level') }}</p></v-col>
        <v-col cols="2">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-select
            v-model="item.riskLevel" :items="riskLevels" item-text="title" item-value="value" class="w-auto"
            :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }"
            outlined dense hide-details :disabled="isNotEditable"
          />
        </v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="1"><p class="label">{{ $t('sod.ttl.risk.type') }}</p></v-col>
        <v-col cols="2">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-select
            v-model="item.riskType" :items="riskTypes" item-text="title" item-value="value" class="w-auto"
            :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }"
            outlined dense hide-details
          />
        </v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ `${$t('sod.ttl.ra')} ${$t('sod.ttl.desc')}` }}</p></v-col>
        <v-col cols="7"><v-text-field v-model="item.raDesc" outlined dense hide-details :disabled="isNotEditable"/></v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="1"><p class="label">{{ $t('sod.ttl.is.active') }}</p></v-col>
        <v-col cols="2"><v-checkbox v-model="item.isActive" :true-value="1" :false-value="0" dense hide-details/></v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" :disabled="!isSavable" small color="primary" @click="saveRa">{{ $t('common.save') }}</v-btn>
      <v-btn class="mr-2" small color="primary" @click="cancelRa">{{ $t('common.cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { isEmpty } from 'lodash';

import { api } from '@/api/common/instances';
import { SOD_RISK_LEVEL, SOD_RISK_TYPE } from '@/constants';

export default {
  props: {
    raId: {
      type: Number,
    },
  },
  data() {
    return {
      item: {},
      riskLevels: SOD_RISK_LEVEL(),
      riskTypes: SOD_RISK_TYPE(),
    };
  },
  computed: {
    isSavable() {
      return !isEmpty(this.item.raNm) && !isEmpty(this.item.riskLevel);
    },
    isNotEditable() {
      return this.item.isSstm == 1 ? true : false;
    },
  },
  watch: {
    raId: {
      handler(val) {
        if (val == 0) this.item = {};
        else this.fetchRa();
      },
    },
  },
  methods: {
    async saveRa() {
      if (await this.$dialog.confirm(this.$t('common.save.q'))) {
        const { status } = await api.post('/sod/ra', this.item);
        if (status === 200) {
          this.$snackbar(this.$t('common.successful'));
          this.$emit('close', 'save');
          this.item = {};
        }
      }
    },
    cancelRa() {
      this.$emit('close', 'cancel');
      this.item = {};
    },
    async fetchRa() {
      const params = { raId: this.raId };
      const { data: item } = await api.get('/sod/ra', { params });
      this.item = item;
    },
  },
};
</script>

<style scoped>
.label {
  text-align: right;
  padding: 4px 15px 0px 0px;
}
.v-text-field {
  width: 100%;
}
</style>
